import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { Map as ImmutableMap, OrderedMap, Set as ImmutableSet } from 'immutable';
import { NONE } from 'customer-data-filters-ui/filterQueryFormat/timestamps/TimestampTypes';
import { ObjectTypeIdRegex } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { STRING } from './OperationTypes';
import { __ANY_FORM, __ANY_WEBINAR, __OCCURRED_INTEGRATION_PROPERTY, __PRIVACY_CONSENT } from './ListSegConstants';
import { testDynamicFilterFamily } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import AnyFormSubmissionField from './specialFields/AnyFormSubmissionField';
import AnyWebinarField from './specialFields/AnyWebinarField';
import EmailSubscriptionField from './specialFields/EmailSubscriptionField';
import makeIntegrationOccurredField from './specialFields/makeIntegrationOccurredField';
import MissingField from 'customer-data-filters-ui/filterQueryFormat/MissingField';
import PageViewField from './specialFields/PageViewField';
import PrivacyConsentField from './specialFields/PrivacyConsentField';
import SmsSubscriptionField from './specialFields/SmsSubscriptionField';
import WhatsAppSubscriptionField from './specialFields/WhatsAppSubscriptionField';
const ContactFilterPropertyAllowlist = ImmutableSet.of('associatedcompanyid');
const ContactFilterPropertyBlockList = ImmutableSet.of('_inbounddbio.importid_', 'formSubmissions.formId', 'listMemberships.listId', 'associations.company', 'associations.contact', 'ilsListMemberships.listId');
export const getSpecialField = (id, assetFamily) => {
  const defaultField = MissingField({
    name: `${id}`,
    timestampType: NONE,
    type: STRING
  });
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily)) {
    return makeIntegrationOccurredField();
  }
  switch (assetFamily) {
    case DSAssetFamilies.EMAIL_SUBSCRIPTION:
      if (id === DSAssetFamilies.EMAIL_SUBSCRIPTION) {
        return EmailSubscriptionField();
      }
      break;
    case DSAssetFamilies.SMS_SUBSCRIPTION:
      if (id === DSAssetFamilies.SMS_SUBSCRIPTION) {
        return SmsSubscriptionField();
      }
      break;
    case DSAssetFamilies.WHATSAPP_SUBSCRIPTION:
      if (id === DSAssetFamilies.WHATSAPP_SUBSCRIPTION) {
        return WhatsAppSubscriptionField();
      }
      break;
    case DSAssetFamilies.CONTACT_PROPERTY:
    case DSAssetFamilies.PRIVACY_CONSENT:
      if (id === __PRIVACY_CONSENT) {
        return PrivacyConsentField();
      }
      break;
    case DSAssetFamilies.FORM:
      if (id === __ANY_FORM) {
        return AnyFormSubmissionField();
      }
      break;
    case DSAssetFamilies.PAGE_VIEW:
      if (id === DSAssetFamilies.PAGE_VIEW) {
        return PageViewField();
      }
      break;
    case DSAssetFamilies.GOTO_WEBINAR_WEBINAR:
      if (id === __ANY_WEBINAR) {
        return AnyWebinarField();
      }
      break;
    default:
      return defaultField;
  }
  return defaultField;
};
export const isSpecialField = (key, assetFamily) => {
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily)) {
    return key === __OCCURRED_INTEGRATION_PROPERTY;
  }
  switch (assetFamily) {
    case DSAssetFamilies.CONTACT_PROPERTY:
    case DSAssetFamilies.PRIVACY_CONSENT:
      return key === __PRIVACY_CONSENT;
    case DSAssetFamilies.FORM:
      return key === __ANY_FORM;
    case DSAssetFamilies.EMAIL_SUBSCRIPTION:
      return key === DSAssetFamilies.EMAIL_SUBSCRIPTION;
    case DSAssetFamilies.PAGE_VIEW:
      return key === DSAssetFamilies.PAGE_VIEW;
    case DSAssetFamilies.GOTO_WEBINAR_WEBINAR:
      return key === __ANY_WEBINAR;
    default:
      return false;
  }
};
const isVisibleFilterProperty = (__scopes, {
  hidden,
  name
}) => {
  if (ContactFilterPropertyBlockList.contains(name)) {
    return false;
  }
  if (ContactFilterPropertyAllowlist.contains(name)) {
    return true;
  }
  return !hidden;
};
const getSpecialFieldsMap = assetFamily => {
  let key = null;
  if (testDynamicFilterFamily(DSAssetFamilies.INTEGRATION, assetFamily)) {
    key = __OCCURRED_INTEGRATION_PROPERTY;
  } else {
    switch (assetFamily) {
      case DSAssetFamilies.EMAIL_SUBSCRIPTION:
      case DSAssetFamilies.SMS_SUBSCRIPTION:
      case DSAssetFamilies.WHATSAPP_SUBSCRIPTION:
      case DSAssetFamilies.PAGE_VIEW:
        key = assetFamily;
        break;
      case DSAssetFamilies.CONTACT_PROPERTY:
        key = __PRIVACY_CONSENT;
        break;
      case DSAssetFamilies.FORM:
        key = __ANY_FORM;
        break;
      case DSAssetFamilies.GOTO_WEBINAR_WEBINAR:
        key = __ANY_WEBINAR;
        break;
      default:
        key = null;
    }
  }
  if (key !== null) {
    return ImmutableMap({
      [key]: getSpecialField(key, assetFamily)
    });
  }
  return ImmutableMap();
};
export const getVisibleFields = (fields, filterFamily, scopes) => {
  const specialFields = getSpecialFieldsMap(filterFamily);
  const fieldsBase = OrderedMap();
  if (fields === undefined) {
    return specialFields.size === 0 ? undefined : fieldsBase.merge(specialFields);
  }
  return fieldsBase.merge(specialFields, fields).filter(field => {
    if (MissingField.isMissingField(field)) {
      return false;
    }
    if (ObjectTypeIdRegex.test(filterFamily)) {
      return isVisibleFilterProperty(scopes, field) && !field.isHiddenFromSelect;
    }
    return !field.isHiddenFromSelect;
  });
};